var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.formattedUsers,"append-icon":"mdi-magnify","loading":_vm.isLoading,"disabled":_vm.isLoading,"small-chips":"","clearable":""},model:{value:(_vm.chosenUser),callback:function ($$v) {_vm.chosenUser=$$v},expression:"chosenUser"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }